import * as React from 'react'
import { LogPointsTopBarMessage } from './LogPointsTopBarMessage'
import { LogPointsTopBarButton } from './LogPointsTopBarButton'
import { LogPointsType } from '../../../LogPointsPage/model'
import './LogPointsTopBar.css'

export type ValueProps = {
  type: LogPointsType
  hasChanges: boolean
  isSaving: boolean
  disabledButton?: boolean
  hasSavedYet: boolean
  error?: any
  messageHref?: string
}

export type EventProps = {
  save: () => void
}

export type Props = ValueProps & EventProps

export class LogPointsTopBar extends React.Component<Props, {}> {

  constructor(props: Props) {
    super(props)

    this.basicItemProps = this.basicItemProps.bind(this)
    this.topBarMessageProps = this.topBarMessageProps.bind(this)
    this.topBarButtonProps = this.topBarButtonProps.bind(this)
    this.saveChanges = this.saveChanges.bind(this)
  }

  basicItemProps() {
    const {hasChanges, isSaving, error, hasSavedYet} = this.props
    return {hasChanges, isSaving, error, hasSavedYet}
  }

  topBarMessageProps() {
    const {messageHref} = this.props
    return {...this.basicItemProps(), messageHref: messageHref}
  }

  topBarButtonProps() {
    return {...this.basicItemProps(), disabledButton: this.props.disabledButton, saveChanges: this.saveChanges}
  }

  saveChanges() {
    this.props.save()
  }

  title() {
    const {type} = this.props

    if (type === LogPointsType.APPLICATION) return 'Select the connectors for which you want to generate logs'
    else return 'Select the properties for which you want to generate logs'
  }

  render() {
    const topBarLabel = this.title()

    return (
      <div className="log-points-page-top-bar" data-test-id="log-points-page-top-bar">
        <span className="log-points-page-top-bar-label" data-test-id="log-points-page-top-bar-label">{topBarLabel}</span>
        <div className="log-points-page-top-bar-button-message-container" data-test-id="log-points-page-top-bar-button-message-container">
          <LogPointsTopBarMessage {...this.topBarMessageProps()}/>
          <LogPointsTopBarButton {...this.topBarButtonProps()}/>
        </div>
      </div>
    )
  }
}
